import list from '../components/list'

export default {

    components: {
        list
    },

    data () {
        return {
            lister: {
                errors: {}
            },
            settings: {
                url: '/employees/list',
                query: {
                    text: ''
                },
                columns: [
                    { column: 'check', name: '', class: 'col-1', sortable: false }
                ],
                bulk_actions: [
                    { event: 'disableAccounts', label: 'Inaktivera konton' }
                ]
            },
            bulk_selected: []
        }
    },

    provide () {
        return {
            export: this.export,
            get_bulk_selected: () => this.bulk_selected,
            trigger_bulk_action: this.trigger_bulk_action,
            trigger_mass_toggle: this.trigger_mass_toggle
        }
    },

    computed: {
        test () {
            return this.bulk_selected
        }
    },

    methods: {

        openExportModal () {
            this.$refs.list.openExportModal()
        },

        trigger_bulk_action (action) {
            console.log('trigger bulk action')
            console.log(action)

            this[action]()
        },

        refresh () {
            this.$refs.list.get()
        },

        trigger_mass_toggle (ids) {
            console.log('ids')
            console.log(ids)

            if (this.bulk_selected.length === ids.length) {
                this.bulk_selected = []
                return
            }
            this.bulk_selected = ids
        }

    }
}
